import type { NDateLocale } from './enUS'
import { enUS } from 'date-fns/locale'

const dateKyKG: NDateLocale = {
  name: 'ky-KG',
  locale: enUS
}

export default dateKyKG
